import * as Yup from "yup";

export const hikeDetailValidation = Yup.object().shape({
  companyCode: Yup.number().required("Company code is required"),
  employeeCode: Yup.number().required("Employee code is required"),
  department: Yup.number().required("Department is required"),
  position_Title: Yup.string(), //.required(""),
  currentBaseSalary: Yup.number()
    .typeError("Current Base Salary is must be a number")
    .required("Current Base Salary is required"),
  newSalary: Yup.number()
    .typeError("New Salary is must be a number")
    .required("New Salary is required"),
  hikePercentage: Yup.number()
    .typeError("Hike Percentage is must be a number")
    .required("Hike Percentage is required"),
  hikeAmount: Yup.number()
    .typeError("Hike Amount is must be a number")
    .required("Hike Amount is required"),
  isActive: Yup.bool().required(""),
  effectiveDate: Yup.string()
    .typeError("Effective Date must be a date")
    .required("Effective Date is required"),
  // hikeAppraiser: Yup.string().default(""),
  isApproved: Yup.bool().required("Is Approved is required"),
  approvedDate: Yup.string().when("isApproved", {
    is: (val) => val === true,
    then: (schema) => schema.required("Approved Date is required"),
    // .matches(/^[A-Z]\d{7}[A-Z]$/, "Invalid Fin Number format"),
    otherwise: (schema) => schema.notRequired(),
  }),
  approvedBy: Yup.string().when("isApproved", {
    is: (val) => val === true,
    then: (schema) => schema.required("Approved By is required"),
    // .matches(/^[A-Z]\d{7}[A-Z]$/, "Invalid Fin Number format"),
    otherwise: (schema) => schema.notRequired(),
  }),

  // approvedDate: Yup.string(),
  // approvedBy: Yup.string(),
  approvalSignature: Yup.string(),
  employeeSignature: Yup.string(),
});
